var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-help",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.853,
    height: 25.853,
    viewBox: "0 0 25.853 25.853",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M13.816,6.552A4.312,4.312,0,0,0,8.5,10.747a.616.616,0,0,0,1.231,0,3.08,3.08,0,1,1,4.274,2.836A2.951,2.951,0,0,0,12.193,16.3V17.67a.616.616,0,0,0,1.231,0V16.3a1.723,1.723,0,0,1,1.059-1.586A4.336,4.336,0,0,0,17,9.738,4.255,4.255,0,0,0,13.816,6.552Z",
    transform: "translate(0.118 -0.359)",
    fill: "#696969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M12.137,16.563h-.012a.611.611,0,0,0-.609.616.619.619,0,1,0,.622-.616Z",
    transform: "translate(0.814 1.981)",
    fill: "#696969"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M14.426,1.5A12.926,12.926,0,1,0,27.353,14.426,12.941,12.941,0,0,0,14.426,1.5Zm0,24.622a11.7,11.7,0,1,1,11.7-11.7A11.709,11.709,0,0,1,14.426,26.122Z",
    transform: "translate(-1.5 -1.5)",
    fill: "#696969"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon2);
export default __webpack_public_path__ + "static/media/helpIcon2.8651fdf3c7f555bafb0092216298b706.svg";
export { ForwardRef as ReactComponent };